import { render, staticRenderFns } from "./TraxUiDatetime.vue?vue&type=template&id=317427b6&scoped=true"
import script from "./TraxUiDatetime.vue?vue&type=script&lang=js"
export * from "./TraxUiDatetime.vue?vue&type=script&lang=js"
import style0 from "./TraxUiDatetime.vue?vue&type=style&index=0&id=317427b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317427b6",
  null
  
)

export default component.exports